export const LOCAL_STORAGE_PREFIX = 'i18n_';
